var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./VuetablePaginationDropdown.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-397c17ed\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./VuetablePaginationDropdown.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VuetablePaginationDropdown.vue
// module id = 50
// module chunks = 1